import { A } from '@ember/array';
import EmberObject from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { initializePropertyDefaults } from 'sh-www/utils/initialize-state-properties';

/**
 * Available banner message types allowed.
 *
 * @type {Object}
 */
export const BANNER_MESSAGE_TYPES = {
  PENDING_PROPOSALS_FOR_ACTIVE_APPLICATION: 'pending_proposals_active_application',
  POSTING_DRAFT_SUCCESS: 'posting-draft-success',
  POSTING_SUBMISSION_SUCCESS: 'posting-submission-success',
  POSTING_SUBMISSION_SUCCESS_SELECT: 'posting-submission-success-select',
};

/**
 * The state for all application-wide information.
 */
export default Service.extend({
  session: service(),

  /**
   * Setup default state here
   */
  propertyDefaults: {
    /**
     * Set of all banner dismissed booleans.  For each banner dismissal we will have an individual boolean
     * indexed by the bannerMessageType.  This is to track dismissals for each different type.
     *
     * @return {{
     *            bannerMessageType: <Boolean>
     *          }}
     */
    bannerDismissedSet: () => EmberObject.create({}),

    /**
     * This is an object filled with arbitrary data which is based on the bannerMessageType passed.
     *
     * @type {Object}
     */
    bannerMessageMeta: () => EmberObject.create({}),

    /**
     * @type {String|null}    of type BANNER_MESSAGE_TYPES.* or null if none is set.
     */
    bannerMessageType: null,

    /**
     * TODO: can take out after investigation of ticket https://storyhunter-dev.atlassian.net/browse/SD-12
     *
     * @type {Boolean}        Will be set to true when the user has succesfully authenticated.
     */
    debug__IsAuthenticated: false,

    /**
     * @type {Boolean}        True if the banner has been dismissed.
     */
    isBannerDismissed: false,

    /**
     * @type {Boolean}        True if the banner in the application is loading.
     */
    isBannerLoading: false,

    /**
     * The list of all the recent activity feed items in our state.
     *
     * @type {Ember.A<ActivityFeedItem>}
     */
    mostRecentActivityFeedItems: () => A(),

    /**
     * These are the most recent inbox threads as loaded by the action nav.
     *
     * @type {Ember.A<Thread>}
     */
    mostRecentInboxThreads: () => A(),
  },

  /** @inheritDoc */
  init() {
    this._super(...arguments);
    initializePropertyDefaults(this);
  },
});
